import { Flex } from '../UI/Flex/Flex';
import { useEffect, useRef, useState } from 'react';
import lottie, { AnimationItem, AnimationSegment } from 'lottie-web';
interface LottieAnimProps {
    width: number;
    height: number;
    data: any;
    onClick?: () => void;
    onFrame?: (lottie: AnimationItem) => void;
}

export const LottieAnim = (props: LottieAnimProps) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const lottieInstance = useRef<AnimationItem | null>(null);
    const animationData = props.data;

    const callbackRef = useRef(props.onFrame);
    useEffect(() => {
        callbackRef.current = props.onFrame;
    }, [props.onFrame]);

    useEffect(() => {
        if (containerRef.current) {
            console.log('Create LOTTIE');
            lottieInstance.current = lottie.loadAnimation({
                container: containerRef.current,
                renderer: 'svg',
                autoplay: true,
                animationData
            });
        }

        const onEnterFrame = () => {
            const animation = lottieInstance.current as AnimationItem;
            if (callbackRef.current) {
                callbackRef.current?.(animation);
            }
        };

        lottieInstance.current?.addEventListener('enterFrame', onEnterFrame);
        return () => {
            lottieInstance.current?.removeEventListener(
                'enterFrame',
                onEnterFrame
            );
            lottieInstance.current?.destroy();
        };
    }, [containerRef.current, animationData]);

    const play = () => lottieInstance.current?.play();
    const pause = () => lottieInstance.current?.pause();
    const stop = () => lottieInstance.current?.stop();
    const goToFrame = (frame: number) =>
        lottieInstance.current?.goToAndStop(frame, true);

    return (
        <div
            onClick={props.onClick}
            style={{ width: props.width, height: props.height }}
        >
            <div ref={containerRef} />
        </div>
    );
};
